import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// import { setPartnerMenu, setAziendaMenu } from './siteMapsSlice'
// import { useDispatch } from 'react-redux'

const API_URL = 'https://apis-csvc-v0-2faa314f421f.herokuapp.com' // <<== da sostituire con variabile d'ambiente in .env
// const API_URL = 'http://localhost:5700' // <<== da sostituire con variabile d'ambiente in .env


//  ========  createAsyncThunk  ========  \\
export const setCurrentUserByToken = createAsyncThunk('questionari/getUtenteByEmailUsername', async (token) => {
  // STEP 1 - Estraggo emailUsername dal token ricevuto
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    const parsedPayload = JSON.parse(jsonPayload);
    const emailUsername = parsedPayload.emails [0];

  // STEP 2 - Invio all'API server richiesta sui dati dell'utente

  const endpoint = `${API_URL}/utenti/utenteByEmailUsername/${encodeURIComponent(emailUsername)}`;
  console.log ('fetchUtenteCorrente - endpoint: ', endpoint)

  const response = await fetch(endpoint);
    if (!response.ok) throw Error(response.statusText);
    const json = await response.json();
    return json;
  }
)

/*
function decodeJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}  


function getUtenteCsvcUuid(token) {
    //  FUNZIONE PROVVISORIA DA SOSTITUIRE CON ALLINEAMENTO TOKEN - DOCUMENTO utenti SU MONGO-DB:
    
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    const parsedPayload = JSON.parse(jsonPayload);
    const emailUsername = parsedPayload.emails [0];
    return emailUsername==='antonio.antonelli@protonmail.com' ? "b3231a39-5539-4a8a-8750-29bfab458f27"
    : emailUsername==='antonio@antonelli.ge.it' ? '92a879ba-bab5-4768-a788-2dcc036f2b5e'
    : emailUsername==='antonio.antonelli@gmail.com' ? '507d18b2-9500-473c-8755-d86023a6e2b0'
    : emailUsername==='antonio.antonelli@spcsas.it' ? 'aadf3299-20c1-4414-af46-1424222b36ab'
    : '92564d8e-649d-4d10-9e8b-abf1061439d0';
}  
*/


/***********************************************
 * 
 *  Inserire chiamata a backend per allineara lo stato dell'utente con quello
 *  del documento MongoDB 'utenti', in particolare aggiungere corretta inizializzazione di :
 * 
 *  - state.emailUsername
 *  - state.csvcUuid
 * 
 * ******************************************* */
// const dispatch = useDispatch();

const utenteCorrenteSlice = createSlice({
    name:'utenteCorrente',
    initialState: {
        data: null,
        status: 'idle',
        error: null,
    
        csvcUuid:"",
//        idp:"",
        idpId:"",
        name:"",
        givenName:"",
        familyName:"",
        csvcRole:"",
        emailUsername:""
    },
    reducers: {
    },

  extraReducers: builder => {

    // Step 1 - setCurrentUserByToken: Gestire lo stato della fetchQuestCorrente
    builder.addCase(setCurrentUserByToken.pending,     (state) => {
        state.status = 'loading'
    })

    builder.addCase(setCurrentUserByToken.fulfilled,   (state, action) => {
        state.status = 'succeded'
        state.csvcUuid =  action.payload[0].csvcUuid;    
//        state.idp = action.payload[0].idp;
        state.idpId = action.payload[0].idpId;
        state.name = action.payload[0].name;
        state.givenName = action.payload[0].givenName;
        state.familyName = action.payload[0].familyName;
        state.csvcRole = action.payload[0].csvcRole; 
        state.emailUsername = action.payload[0].emailUsername;

        // Dispatch to siteMapsSlice
        // store.dispatch(updateSiteMap(action.payload[0].siteMapData));
        /*
        switch (action.payload[0].csvcRole) {
            case 'partner':
                dispatch(setPartnerMenu())
                // dispatch(unsetCapitoloMenu('xxxx'))
                break
            case 'azienda':
                dispatch(setAziendaMenu())
                // dispatch(unsetCapitoloMenu('xxxx'))
                break
            default:
                dispatch(setPartnerMenu())
        }
        */

    })

    builder.addCase(setCurrentUserByToken.rejected,    (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message  // from createAsyncThunk    
    })
}
})

export const { setCurrentUser } = utenteCorrenteSlice.actions
export const utenteCorrenteReducer = utenteCorrenteSlice.reducer
